import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-facility-icon',
  templateUrl: './facility-icon.component.html',
  styleUrls: ['./facility-icon.component.scss']
})
export class FacilityIconComponent implements OnInit {

  @Input() logo = 'light';
  @Input() width = '306px';

  constructor() { }

  ngOnInit() {

  }

}
